import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tooltipList'
})
export class TooltipListPipe implements PipeTransform {

  transform(lines: any): string {
    let list: string = "";

    lines.forEach(line => {
      if ('quantity' in line) {
        list += `• ${line.quantity}*${line.container_size_type.display} (${line.condition.value}) \n`;
      } else {
        list += `• ${line.name_display} \n`;
      }
    });

    return list;
  }

}
